import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  IconButton,
  Typography,
  Box,
  MenuItem,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { PRIORITY_OPTIONS } from './ManageProductsModal';

function ProductModal({ open, setOpen, product, onSave, mode = 'edit', dropDownValues }) {
  const isEditMode = mode === 'edit';
  console.log(product, 'add');
  const initialFormState = {
    botanicalName: '',
    contractUniqueID: product?.contractUniqueID,
    destinationSiteAssessmentID: product?.siteAssessmentId,
    destination: '',
    estimatedQty: '',
    productGroup: '',
    productSource: '',
    purchasePrice: '',
    priority: '1',
    // species: '',
    vatRate: '',
  };

  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    if (isEditMode && product) {
      setFormData({
        botanicalName: product.botanicalName || '',
        contractUniqueID: product.contractUniqueID || '',
        destination: product.destination || '',
        estimatedQty: product.estimatedQty ?? '',
        productGroup: product.productGroup || '',
        productSource: product.productSource || '',
        purchasePrice: product.purchasePrice ?? '',
        priority: product?.priority ?? '1',
        // species: product.species || '',
        vatRate: product.vatRate ?? '',
        destinationSiteAssessmentID: product?.siteAssessmentId,
      });
    } else if (!isEditMode) {
      setFormData(initialFormState);
    }
  }, [product, isEditMode, open]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setFormData(initialFormState);
    setOpen(false);
  };

  const handleSubmit = () => {
    // Prepare data for submission
    const productData = {
      ...(isEditMode && product ? { id: product.id, siteAssessmentId: product.siteAssessmentId } : {}),
      ...formData,
      // Convert numeric fields
      estimatedQty: formData.estimatedQty === '' ? null : Number(formData.estimatedQty),
      purchasePrice: formData.purchasePrice === '' ? null : Number(formData.purchasePrice),
      vatRate: formData.vatRate === '' ? null : Number(formData.vatRate),
    };

    // Call the onSave callback
    if (onSave) {
      onSave(productData, mode);
    }

    handleClose();
  };

  const isFormValid = () => {
    // Add your validation logic here
    return formData.productGroup && formData.destination && formData.contractUniqueID;
  };
  console.log(dropDownValues, 'val');
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '90vh',
        },
      }}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" component="div">
            {isEditMode ? 'Edit Product' : 'Add New Product'}
          </Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close" sx={{ color: 'grey.500' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contract Unique ID"
              name="contractUniqueID"
              value={formData.contractUniqueID}
              onChange={handleChange}
              disabled={true}
              variant="outlined"
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Product Group"
              name="productGroup"
              value={formData.productGroup}
              onChange={handleChange}
              variant="outlined"
              required>
              {dropDownValues.product?.map(item => (
                <MenuItem key={item.id} value={item.productName}>
                  {item.productName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Species"
              name="species"
              value={formData.species}
              onChange={handleChange}
              variant="outlined">
              {dropDownValues.species?.map(item => (
                <MenuItem key={item.id} value={item.keyValue}>
                  {item.keyValue}
                </MenuItem>
              ))}
            </TextField>
          </Grid> */}
          {/* <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Botanical Name"
              name="botanicalName"
              value={formData.botanicalName}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Destination"
              name="destination"
              value={formData.destination}
              onChange={handleChange}
              variant="outlined"
              required>
              {dropDownValues.destinations?.map(item => (
                <MenuItem key={item.id} value={item.destinationName}>
                  {item.destinationName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Priority"
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              variant="outlined"
              required>
              {PRIORITY_OPTIONS.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* 
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Product Source"
              name="productSource"
              value={formData.productSource}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Purchase Price"
              name="purchasePrice"
              type="number"
              value={formData.purchasePrice}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ step: '0.01', min: '0' }}
            />
          </Grid> */}
          {/* 
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Estimated Qty"
              name="estimatedQty"
              type="number"
              value={formData.estimatedQty}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ step: '1', min: '0' }}
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="VAT Rate (%)"
              name="vatRate"
              type="number"
              value={formData.vatRate}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ step: '0.1', min: '0', max: '100' }}
            />
          </Grid> */}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={handleClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary" disabled={!isFormValid()}>
          {isEditMode ? 'Save Changes' : 'Add Product'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProductModal;
